import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
        },
        {
          text: i18n.t("model.prop.name"),
          value: "name",
        },
        {
          text: "Code",
          value: "tuitionCode",
        },
        {
          text: "Players",
          value: "_count.TuitionPlayer",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Player",
        label: "Players",
      },
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: i18n.t("model.prop.name"),
          value: "name",
        },
        {
          text: "Code",
          value: "code",
        },
        {
          text: "Description",
          value: "description",
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "string",
        key: "name",
        name: i18n.t("model.prop.name"),
      },
      {
        type: "string",
        key: "code",
        name: "Code",
      },
      {
        type: "string",
        key: "description",
        name: "Description",
        defaultValue: "Every Tuesday at 02:00 PM",
      },
    ],
    rules: {
      name: [(v) => !!v || i18n.t("rules.name")],
      code: [
        (v) => !!v || "Code is required",
        (v) => /^\d{6}$/.test(v) || "Code must be exactly 6 digits",
      ],
    },
  },
  edit: true,
  delete: true,
};
